import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import { translate } from 'react-i18next';

const ParticipantAddressDetails = ({ address }) => (
  <React.Fragment>
    <Grid container spacing={2}>
      <Grid item>
        <Typography variant="caption" color="textSecondary">Ulica</Typography>
        <Typography gutterBottom>{address.street}</Typography>
      </Grid>
      <Grid item>
        <Typography variant="caption" color="textSecondary">Nr domu</Typography>
        <Typography gutterBottom>{address.streetNumber}</Typography>
      </Grid>
      <Grid item>
        <Typography variant="caption" color="textSecondary">Nr mieszkania</Typography>
        <Typography gutterBottom>{address.apartmentNumber}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={2}>
      <Grid item>
        <Typography variant="caption" color="textSecondary">Kod pocztowy</Typography>
        <Typography gutterBottom>{address.zipCode}</Typography>
      </Grid>
      <Grid item>
        <Typography variant="caption" color="textSecondary">Miejscowość</Typography>
        <Typography gutterBottom>{address.city}</Typography>
      </Grid>
    </Grid>
  </React.Fragment>
);

ParticipantAddressDetails.propTypes = {
  address: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(ParticipantAddressDetails);



// WEBPACK FOOTER //
// ./src/components/userProfile/ParticipantAddressDetails.js